<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.tedarikci_karti"  url="BrandSupplierScorecards" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-4">

<Accordion :activeIndex="[0]" :multiple="true">


<AccordionTab header="Kart Bilgileri">
<ClickEditInputText  title="İsim" :value="item.name" valkey="name" @dataChanged="dataChanged"></ClickEditInputText>

<ClickEditSwitch  title="Aktif" :value="item.active" valkey="active" @dataChanged="dataChanged" />

<ClickEditSwitch  title="Tedarikçilerle Paylaş" :value="item.share_with_suppliers" valkey="share_with_suppliers" @dataChanged="dataChanged" />


<ClickEditSwitch  title="Dashboardda Göster" :value="item.show_on_dashboard" valkey="show_on_dashboard" @dataChanged="dataChanged" />
<ClickEditCalendar  title="Geçerlilik Tarihi" :value="item.valid_until" valkey="valid_until" @dataChanged="dataChanged" v-if="item.show_on_dashboard"/>


</AccordionTab>






<AccordionTab header="Kart Çeviri Alanları">
<template v-for="translation in item.translations">
  
<ClickEditInputText  :title="translation.language.name+' çeviri'" :value="translation.translation" :valkey="translation.id" @dataChanged="translationChanged"></ClickEditInputText>

<ClickEditInputTextArea  :title="translation.language.name+' yardım metni'" :value="translation.description" :valkey="translation.id" @dataChanged="translationDescriptionChanged"></ClickEditInputTextArea>
</template>
</AccordionTab>



<AccordionTab header="Kart Koşulları">


<BrandSupplierScorecardCondition
v-for="condition in item.conditions"
:condition="condition"
:customattributes="customattributes"
@deleteCondition="deleteCondition"
:key="condition.id"
/>


<div class="col-12" v-if="!adding_condition">
<Button label="Yeni Koşul Ekle"  class="p-button-outlined p-button-sm p-button-primary"   @click="addCondition"></Button>
</div>



</AccordionTab>


<AccordionTab header="Kart Tasarımları">
<div class="grid">
<div class="col-12" v-for="translation in item.translations">



<Button icon="pi pi-pencil" :label="translation.language.name+' tasarım'" class=" p-button-primary p-button-outlined  p-button-sm mr-2" @click="showEditorModal(translation.id)"></Button>

</div>
</div>
</AccordionTab>


<!-- old type items 

<AccordionTab header="Kart Verisi">
<div class="grid">
<draggable
class="col-12"
v-model="carditems"
v-bind="dragOptions"
@start="drag = true"
@end="dragEnd"
item-key="id"
handle=".handle"
>
<template #item="{ element }">


<BrandSupplierScorecardItem 
:element="element" 
:customattributes="customattributes" 
:languages="languages" 
:brandreports="brandreports" 
/>


</template>
</draggable>

<div class="col-12">
<Button :label="$store.state.languages.lang_phrases.yeni_ekle" class=" p-button-primary p-button-outlined  p-button-sm" @click="addNewCardItem"></Button>
</div>
</div>
</AccordionTab>

old type items -->



</Accordion>





</div>
</template>


<BrandSupplierScorecardEditor />

</div>	
</template>

<script>
const card_item = {
	id:null,
	name:null,
	translations:[],
	source_id:null,
	sourceitem_id:null,
	source_type:null,
  status:0,
  editing:true,
}
import BrandSupplierScorecardItem from "./BrandSupplierScorecardItem"
import BrandSupplierScorecardEditor from "./BrandSupplierScorecardEditor"
import BrandSupplierScorecardCondition from "./BrandSupplierScorecardCondition"



export default {

  name: 'BrandSupplierScorecard',
  components:{BrandSupplierScorecardItem,BrandSupplierScorecardEditor,BrandSupplierScorecardCondition},
  data () {
    return {
    	loading:true,
    	item:null,
    	languages:[],
    	carditems:[],
    	customattributes:[],
    	brandreports:[],
    	drag:false,
    	newcarditem:null,  
      adding_condition:false,    
      new_condition:{
        id:null,
        customattribute_id:null,
        logic_operator:null,
        numericalval:null,
        textval:null,
      }
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
    async deleteCondition(data)
    {
      console.log(data)
      this.adding_condition = false
      this.item.conditions = await this.generalApiGetWithoutLoader("get_scorecard_conditions/"+this.$route.params.card_id)
    },
    addCondition()
    {
      
      let condition = this.sanitizeArray(this.new_condition)
      condition.id = "new" 
      this.item.conditions.push(condition)
      this.adding_condition = true
    },
    showEditorModal(lang_id)
    {
      this.$store.dispatch('document_editor/setShowModal',true) 
      this.$store.dispatch('document_editor/setEditingTranslation',lang_id) 
    },
  	addNewCardItem()
  	{
  		let new_card_item  = this.sanitizeArray(card_item)
  		new_card_item.id = this.generateId()
  		this.carditems.push(new_card_item)
      
  	},
  	dragEnd()
  	{
  		this.drag = false
  	},
  	async getCustomAttributes()
  	{
  		this.customattributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$route.params.id)
      //console.log("getCustomAttributes")
      //console.log(this.customattributes)
  	},
  	async getBrandReports()
  	{
  		this.brandreports = await this.generalApiGetWithoutLoader("brand_reports/"+this.$route.params.id)
  	},
  	async getData()
  	{
  		this.loading = await true
  		await this.getCustomAttributes()
  		await this.getBrandReports()
  		this.item = await this.generalApiGetWithoutLoader("get_supplier_scorecard/"+this.$route.params.card_id)
  		this.languages = await this.generalApiGetWithoutLoader("languages")
      console.log(this.item)
  		this.carditems = this.item.carditems
  		//console.log(this.item)

  		this.loading = false
  	},
  	translationChanged(data)
  	{
  		let formdata = new FormData()
    	formdata.append("translation",data.value)
    	this.generalSubmission(formdata,"update_supplier_scorecard_translation/"+data.key,this.renewData)
  	},
  	translationDescriptionChanged(data)
  	{
  		let formdata = new FormData()
    	formdata.append("description",data.value)
    	this.generalSubmission(formdata,"update_supplier_scorecard_translation/"+data.key,this.renewData)
  	},
  	dataChanged(data)
    {
    	console.log(data.value)
    	console.log(data.key)
    	let formdata = new FormData()
    	formdata.append(data.key,data.value)
    	this.generalSubmission(formdata,"update_supplier_scorecard/"+this.item.id,this.renewData)
    },
    renewData(response)
    {
    	this.item = response.data
    	console.log("data changed");
    	console.log(response.data);    	
    },
  }
}
</script>

<style lang="css" scoped>
.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
.handle{
	cursor: pointer;

}
</style>